import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { NavbarComponent } from '../navbar/navbar.component';
import { PositionAlertModalComponent } from '../../../features/patrol-alerts/components/remainder-alert/reminders-modal.component';
import { UserProfileModalComponent } from '../user-profile-modal/user-profile-modal.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    CommonModule, 
    RouterOutlet, 
    NavbarComponent, 
    PositionAlertModalComponent,
    UserProfileModalComponent // Importe o modal aqui
  ],
  template: `
    <div class="relative h-screen flex flex-col overflow-hidden bg-white">
      <!-- Navbar fixa no topo -->
      <app-navbar 
        [pageTitle]="pageTitle" 
        [breadcrumbs]="breadcrumbs"
        (openUserProfile)="openUserProfile()">
      </app-navbar>

      <!-- Conteúdo principal -->
      <main class="flex-1 overflow-y-auto">
        <router-outlet></router-outlet>
      </main>

    
      <app-position-alert-modal></app-position-alert-modal>
      
    
      <app-user-profile-modal
        *ngIf="showUserModal"
        (close)="closeUserProfile()"
      ></app-user-profile-modal>
    </div>
  `
})
export class LayoutComponent implements OnInit {
  @Input() pageTitle = 'Dashboard';
  @Input() breadcrumbs: string[] = [];
  
  showUserModal = false;

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/login']);
    }
  }

  openUserProfile(): void {
    this.showUserModal = true;
  }

  closeUserProfile(): void {
    this.showUserModal = false;
  }
}